import { ModalWindow } from './ModalWindow';
export default ModalWindow;



// WEBPACK FOOTER //
// ./src/components/atomic/organisms/ModalWindow/index.js